import { styled } from 'opensolar-ui'

// taken from: app/src/projectSections/sections/manage3/details/elements/filesAndTransactions/files/common/styles/styles.ts
export const LoadingOverlay = styled('div')(({ theme }) => ({
  width: '100vw',
  height: '100vh',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 9999,
  display: 'grid',
  backgroundColor: 'rgba(255,255,255,0.8)',
  '& .MuiLinearProgress-root': {
    position: 'absolute',
    width: 300,
    top: '50%',
    left: 'calc(50% - 150px)',
  },
}))

// taken from: app/src/projectSections/sections/manage3/details/elements/filesAndTransactions/files/common/styles/dialogAndFieldsStyles.ts
export const ContentWrapper = styled('div')(({ theme }) => ({
  padding: '32px 18px',
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
}))
// react-admin fields have a gap between label and field
// this is to match that gap in non react-admin inputs
export const InputRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: 10,
}))
